// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__19Wow","info":"PatientInfo_info__3-g9A"};